import { dontPrefixPaths } from '@arvesta-websites/ui-babel';
import { getSrc } from 'gatsby-plugin-image';

import {
  ContentfulImage,
  ContentfulSettings,
  ContentfulSettingsSiteDescriptionTextNode,
} from '../__generated__/graphql-types';

type PageProps = {
  id: number;
  pageTitle?: string;
  pageDescription?: string;
  pageLocale: string;
  pageType: string;
  siteUrl: string;
  pageSlug: string;
  contentfulSettings: ContentfulSettings;
  isHomepage: boolean;
  ogPageType: string;
  pageSettings?: any;
  pageImage?: ContentfulImage;
  swiftTypeDate?: string;
  swiftTypeLocation?: string;
  updatedAt: string;
};

const buildCanonicalLink = (extractedPageSettings: any, siteUrl: string, locale: string, slug: string) => {
  const pagePath = dontPrefixPaths ? slug : `${locale}/${slug}`;

  return extractedPageSettings && extractedPageSettings.canonicalUrlpath
    ? extractedPageSettings.canonicalUrlpath
    : `${siteUrl}/${pagePath}`;
};

const extractSiteDescription = (item: any) => (item.text ? item.text : item);

const extractImage = (image: any) => {
  if (!image) {
    return null;
  }

  // if (image && image.socialImage && image.socialImage.fixed && image.socialImage.fixed.src) {
  //   return image.socialImage.fixed.src;
  // }
  if (image?.socialImage?.gatsbyImageData) {
    return getSrc(image?.socialImage?.gatsbyImageData);
  }

  // if (image && image.asset && image.asset.fixed && image.asset.fixed.src) {
  //   return image.asset.fixed.src;
  // }
  if (image?.asset?.gatsbyImageData) {
    return getSrc(image?.asset?.gatsbyImageData);
  }

  return null;
};

const getPageDescription = (
  pageDescription: string | undefined,
  extractedSettings: any,
  siteDescription: ContentfulSettingsSiteDescriptionTextNode | undefined | null,
) => {
  const settingsDescription = extractedSettings?.description || extractedSettings?.legacyDescription || '';

  return (
    pageDescription ||
    (extractedSettings && settingsDescription ? settingsDescription : extractSiteDescription(siteDescription))
  );
};

const getPageSettings = (pageSettings: any) => {
  if (!pageSettings) {
    return {};
  }

  const { title, description, nofollow, noindex, canonicalUrlpath, keywords } = pageSettings;

  return {
    canonicalUrlpath,
    description,
    keywords,
    nofollow,
    noindex,
    title,
  };
};

const getSiteMetadata = (pageProps: PageProps) => {
  const {
    id,
    pageTitle,
    pageDescription,
    pageLocale,
    pageType,
    siteUrl,
    pageSlug,
    contentfulSettings,
    isHomepage,
    ogPageType,
    pageSettings,
    pageImage,
    swiftTypeDate,
    swiftTypeLocation,
    updatedAt,
  } = pageProps;

  const { siteDescription, siteImage, siteTitle } = contentfulSettings;

  const extractedPageSettings = getPageSettings(pageSettings);

  const siteData = {
    metaData: {
      canonical: isHomepage
        ? `${siteUrl}/${pageLocale}`
        : buildCanonicalLink(extractedPageSettings, siteUrl, pageLocale, pageSlug),
      description: getPageDescription(pageDescription, extractedPageSettings, siteDescription),
      image: pageImage ? extractImage(pageImage) : extractImage(siteImage),
      nofollow: extractedPageSettings && extractedPageSettings.nofollow ? extractedPageSettings.nofollow : undefined,
      noindex: extractedPageSettings && extractedPageSettings.noindex ? extractedPageSettings.noindex : undefined,
      ogPageType,
      pageLocale,
      pageType,
      searchTags: extractedPageSettings?.keywords,
      siteName: siteTitle,
      swiftTypeDate,
      swiftTypeLocation,
      title: pageTitle || (extractedPageSettings && extractedPageSettings.title ? extractedPageSettings.title : null),
      updatedAt,
    },
    pageId: id,
  };

  return siteData;
};

export default getSiteMetadata;
